import * as countries from "i18n-iso-countries";
import type { LocaleData } from "i18n-iso-countries";

declare function require(path: string): LocaleData;

// Package docs require loading locale JSON this way unless resolveJsonModule is enabled.
// eslint-disable-next-line @typescript-eslint/no-var-requires
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

const unitedStates = "United States";

export const countryOptions = [
  unitedStates,
  ...Object.values(countries.getNames("en", { select: "alias" }))
    .filter((country) => country !== unitedStates)
    .sort((a, b) => a.localeCompare(b)),
];
